import { render } from "./Activity.vue?vue&type=template&id=63cec169"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__